/* eslint-disable max-lines */
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  LoginFormValidate,
  validateQuestionAnswer
} from '@com-delta-idp/mnx-login-ui';
import { VIEW_NAME } from '../../data-access/login-modal/constants/login-constant';
import { LoginModalHelperSuperComponent } from './login-modal-helper-super-component';

@Injectable({
  providedIn: 'root'
})
export class LoginModalHelperComponent extends LoginModalHelperSuperComponent {
  lastNameField = false;

  invalidField() {
    let formGroup: UntypedFormGroup;
    const subject = this.facade.loginContent$.getValue();
    if (subject) {
      formGroup = subject.formGroup;
      LoginFormValidate.focusFirstInvalidFieldHandler(
        formGroup,
        this.elementRef
      );
    }
  }

  resetPasswordFormInvalidField() {
    const subject = this.resetPasswordFacade.resetPasswordContent$.getValue();
    if (subject) {
      LoginFormValidate.focusFirstInvalidFieldHandler(
        subject.formGroup,
        this.elementRef
      );
    }
  }

  onRecoveryOptionsFormSubmit() {
    this.recoveryOptionsFacade.onFormSubmit();
  }

  recoveryOptionsCloseOverlayMessage() {
    this.recoveryOptionsFacade.getContent().hasError = false;
  }

  recoverSQACloseOverlayMessage() {
    this.recoverSQAFacadeService.getSecurityContent().errorCode = undefined;
  }

  onSecurityFormSubmit(userInputFields: validateQuestionAnswer): void {
    this.recoverSQAFacadeService.onFormSubmit(true, userInputFields);
  }

  recoverbySQAFormInvalidField() {
    const subject = this.recoverSQAFacadeService.pageContent$.getValue();
    if (subject) {
      LoginFormValidate.focusFirstInvalidFieldHandler(
        subject.formGroup,
        this.elementRef
      );
    }
  }

  sqaFieldFocusChange(fieldName: string) {
    this.recoverSQAFacadeService.focusChange(fieldName);
  }

  sqaInputChange() {
    this.recoverSQAFacadeService.formValueChange();
  }

  focusInvalidField() {
    const viewName = this.nextDisplayViewService.viewName$.getValue();
    const screens = {
      [VIEW_NAME.RESET_PASSWORD_SCREEN]:
        this.resetPasswordFacade.resetPasswordContent$.getValue(),
      [VIEW_NAME.CREATE_PASSWORD_SCREEN]:
        this.createPasswordFacade.resetPasswordContent$.getValue(),
      [VIEW_NAME.SET_PASSWORD_SCREEN]:
        this.createMyPasswordFacade.pageContent$.getValue(),
      [VIEW_NAME.ADD_EMAIL_ADDRESS_SCREEN]:
        this.addEmailAddressFacadeService.addEmailAddressContent$.getValue(),
      [VIEW_NAME.ADD_ADDRESS_SCREEN]:
        this.addAddressFacade.addAddressContent$.getValue(),
      [VIEW_NAME.ADD_SECURITY_QUESTION_ANS_SCREEN]:
        this.addSqaFacade.addSqaContent$.getValue()
    };
    const subject = screens[viewName];
    if (subject) {
      LoginFormValidate.focusFirstInvalidFieldHandler(
        subject.formGroup,
        this.elementRef
      );
    }
  }

  createMyPasswordFocusInvalidField() {
    let formGroup: UntypedFormGroup;
    const subject = this.createMyPasswordFacade.pageContent$.getValue();
    if (subject) {
      formGroup = subject.formGroup;
      LoginFormValidate.focusFirstInvalidFieldHandler(
        formGroup,
        this.elementRef
      );
    }
  }

  forgotLoginInvalidField() {
    let formGroup: UntypedFormGroup;
    const subject = this.forgotLoginFacade.forgotLoginContent$.getValue();
    if (subject) {
      formGroup = subject.formGroup;
      LoginFormValidate.focusFirstInvalidFieldHandler(
        formGroup,
        this.elementRef
      );
    }
  }
}
